module.exports = __webpack_public_path__ + "static/media/61_tn.f98f1880.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/thumbnails/61_tn.jpg
// module id = 548
// module chunks = 0